<script>
// import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mujerMethods } from "@/state/helpers";
import { tableData } from "../dataAdvancedtable";
import { validateNumber, validateText, validateCurp } from "@/helpers/utils.js";
import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import moment from 'moment';
Vue.use(VueAxios, axios)
/**
 * Dashboard Component
 */
export default {

  page: {
    title: "ActualizaMTarjeta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect
  },
  props: {
    
  },
  data() {
    return {
      checked: true,
      checked1: true,
      label: "",
      active: 1,
      dataOn: "On",
      dataOff: 'Off',
      tarjetas: [],
      estatus: ['Activo','Desactivo'],

// ************************************** Link
      tableData: tableData,
      title: "Nuevo Registro",
      items: [
        {
          text: "Mujeres",
          href: "/Mujeres",
        },
        {
          text: "Nuevo registro",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      whatsapp: "No",
      hijos: "No",
      municipios: [],
      objeto:{
        id_tarjeta:"",
        curp:"",
        nombre:"",
        apellido_paterno:"",
        apellido_materno:"",
        id_tipo:5,
        fecha_nacimiento:"",
        colonia:"",
        celular:"",
        estatus:"Activo",
        fecha_creacion:"",
        fecha_modificacion:"",
        // NUEVOS CAMPOS
        email: "",
        edad: "",
        calle: "",
        numero_exterior: "",
        id_municipio: "",
        escolaridad_terminada: "",
        estado_civil: "",
        ocupacion: "",
        ingreso_mensual: "",
        cantidad_hijos: "",
        cantidad_dependientes_economicos: "",
        edad_primer_hijo: "",
        episodio_violencia: "",
        tipo_violencia: "",
        lugar_violencia: "",
        redes_sociales: [],
        whatsapp: "",
      }
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    pare(){
      return this.$props.sore
    },
    todoList() {
      return this.todos.length;
    },

    municipioList() {
      if(this.municipios.length > 0) {
        const data = this.municipios.map(x => {
          return { text: x.nombre_municipio, value: x.id_municipio, }
        });
        // sort data by alphabetical order
        return data.sort((a, b) => {
          return a.text.localeCompare(b.text);
        })
      } else return [];
    },

    coloniasList() {
      if(this.objeto.id_municipio != "" && this.municipios.length > 0) {
        // give me the list of colonias that are inside the selected municipio
        const colonias = this.municipios.filter(x => {
          return x.id_municipio == this.objeto.id_municipio;
        })
        const coloniasTextValue = colonias[0].colonias.map(x => {
          return { text: x.colonia, value: x.colonia, }
        });
        // sort data by alphabetical order
        return coloniasTextValue.sort((a, b) => {
          return a.text.localeCompare(b.text);
        })
      } else return [];
    },

    // computed that checks if fecha_nacimiento is more than 18 years old
    isAdult() {
      if (this.objeto.fecha_nacimiento) {
        let fecha = this.objeto.fecha_nacimiento;
        const years = moment().diff(fecha, 'years');
        return years >= 18;
      } else {
        return true;
      }
    },
    isAdultEdad() {
      if(this.objeto.edad) return this.objeto.edad >= 18;
      else return true;
    }
  },

  mounted() {
    this.getTarjetas();
    this.getMunicipios();
    this.getUsuario();

    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.
    this.update();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
  },

  methods: {

    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...mujerMethods,

    // get municipios
    getMunicipios() {
      axios.get("/municipios_colonias").then((res) => {
        const { response = "", data = [] } = res.data;
        if (response === true) {
          this.municipios = data;
        }
      });
    },

    // get Tarjetas
    getTarjetas() {
      axios.get("/tarjetas")
      .then((res) => {
        const {response="",data=[]} = res.data;
        if (response === true) {
          const array=[]
          data.forEach(t => {
            array.push(t.folio)
          });
          this.tarjetas = array;
        }
      })
    },

    // get Usuario
    getUsuario() {
      const id_usuario = this.$route.params.id_usuario;
      axios.get(`/usuarios/${id_usuario}`)
      .then((res) => {
        const {response="",data={}} = res.data;
        if (response === true) {
          this.objeto = data
          this.objeto.estatus = data.estatus === 1 ? 'Activo':'Desactivo';
          this.objeto.fecha_nacimiento = moment(data.fecha_nacimiento).format('YYYY-MM-DD')
          this.objeto.fecha_creacion = moment(data.fecha_creacion).format('YYYY-MM-DD')
          this.objeto.fecha_modificacion = moment().format("YYYY-MM-DD");
          this.objeto.whatsapp.length > 0 ? this.whatsapp = 'Si' : this.whatsapp = 'No';
          this.objeto.cantidad_hijos > 0 ? this.hijos = 'Si' : this.hijos = 'No';
        }
      })
    },

    // method that validate keypress only numbers
    validateNumber(event, value, max) {
      if (value) {
        if (value.toString().length + 1 > max) {
          event.preventDefault();
        } else validateNumber(event);
      } else {
        validateNumber(event);
      }
    },
    validateText(event, value, max) {
      if (value) {
        if (value.toString().length + 1 > max) {
          event.preventDefault();
        } else validateText(event);
      } else {
        validateText(event);
      }
    },
    validateLength(event, value, max) {
      if (value) {
        if (value.length + 1 > max) {
          event.preventDefault();
        }
      }
    },
    validateCurp(event, value, max) {
      if (value) {
        if (value.length + 1 > max) {
          event.preventDefault();
        } else validateCurp(event);
      } else {
        validateCurp(event);
      }
    },

    // METODO PARA VALIDACION DE FORM
    checkForm(e) {
      var form = document.getElementById("form-update-woman");
      console.log(form)
      if (form.checkValidity() === true) {
        if(!this.isAdult || !this.isAdultEdad) {
          this.$swal("Alerta", "La edad y fecha de nacimiento deben ser mayor de 18 años", "warning");
        } else  {
          this.handleUpdate()
        }
      }
      form.classList.add('was-validated'); 
      e.preventDefault();
      e.stopPropagation(); 
    },

    handleUpdate(){
      this.objeto.estatus = this.objeto.estatus === 'Activo' ? 1 : 0;
      this.objeto.fecha_modificacion = moment().format("YYYY-MM-DD");
      this.objeto.curp = this.objeto.curp.toUpperCase();
      axios.put("/usuarios",this.objeto)
      .then((res) => {
        const {response=""} = res.data;
        if (response === true) {
          this.$swal(
            'Edición',
            'Datos editados correctamente',
            'success'
          )
          this.$router.push("/Mujeres");
        }else{
          this.$swal(
            'Alerta',
            'No se pudo realizar los cambios',
            'warning'
          );
        }
      })
      .catch(error => {
        this.errorMessage = error.message;
        console.log(error);
        this.$swal(
          'Error',
          'Ocurrio un error',
          'danger'
        );
      });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <v-row>
        <v-col md="12">
          <v-card>
            <b-form id="form-update-woman" novalidate class="needs-validation">
              <div class="card-body">
                <v-col md="12">
                  <v-row>
                    <v-card-text>
                      <h5 class="card-title mb-4">Información de la mujer</h5>
                    </v-card-text>
                    <v-col md="4">
                      <b><label class="form-check-label " >Número de Tarjeta</label> </b>
                      <div class="mb-4">
                        <b-form-input 
                          list="tarjetas_list" 
                          v-model="objeto.id_tarjeta"
                          pattern=".{11,}"
                          @keypress="validateNumber($event, objeto.id_tarjeta, 11)"
                        >
                        </b-form-input>
                        <datalist id="tarjetas_list">
                          <option v-for="tarjeta in tarjetas" :key="tarjeta.id_tarjeta">{{ tarjeta }}</option>
                        </datalist>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b><label class="form-check-label " >CURP</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.curp"
                          id="curp"
                          pattern=".{18}"
                          class="text-uppercase"
                          placeholder="XXAX010101XXXXXX1"
                          @keypress="validateCurp($event, objeto.curp, 18)"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b><label class="form-check-label">Email</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.email"
                          id="input-email"
                          type="email"
                          placeholder="ejemplo@gmail.com"
                        ></b-form-input>
                      </div>
                    </v-col>
                  <v-row>
                    <v-col md="12"> 
                      <h4 class="card-title">Información personal</h4>
                    </v-col>
                    <v-col md="3"> 
                      <b><label class="form-check-label " > Nombre</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.nombre"
                          id="nombre"
                          placeholder="Nombre"
                          @keypress="validateText($event, objeto.nombre, 40)"
                          required
                          trim
                        ></b-form-input>
                      </div>
                    </v-col> 
                    <v-col md="3"> 
                      <b> <label class="form-check-label " > Apellido Paterno</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.apellido_paterno"
                          id="apellido_paterno"
                          placeholder="Apellido Paterno"
                          @keypress="validateText($event, objeto.apellido_paterno, 40)"
                          required
                          trim
                        ></b-form-input>
                      </div>
                    </v-col> 
                    <v-col md="3"> 
                      <b> <label class="form-check-label " > Apellido Materno</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.apellido_materno"
                          id="apellido_materno"
                          placeholder="Apellido Materno"
                          @keypress="validateText($event, objeto.apellido_materno, 40)"
                          required
                          trim
                        ></b-form-input>
                      </div>
                    </v-col>  
                    <v-col md="3">
                      <b><label class="form-check-label " > Fecha de Nacimiento</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_nacimiento"
                          id="fecha_nacimiento"
                          :class="{ 'is-invalid': !isAdult }"
                          type="date"
                          placeholder="Fecha de Nacimiento"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>  
                  </v-row>
                  <v-row>
                    <v-col md="2">
                      <b><label class="form-check-label">Edad</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.edad"
                          id="input-edad"
                          :class="{ 'is-invalid': !isAdultEdad }"
                          @keypress="validateNumber($event, objeto.edad, 2)"
                          placeholder="Coloque su edad"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Calle</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.calle"
                          id="input-calle"
                          placeholder="Ej. Av. Insurgentes"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b><label class="form-check-label">Nu. Exterior</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.numero_exterior"
                          id="input-num-exterior"
                          @keypress="validateNumber($event, objeto.numero_exterior, 5)"
                          placeholder="Num. Exterior"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b><label class="form-check-label">Municipio</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.id_municipio"
                          required
                          :options="municipioList"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.id_municipio">
                      <b><label class="form-check-label">Colonia</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.colonia"
                          required
                          :options="coloniasList"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Celular</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.celular"
                          id="input-celular"
                          placeholder="Celular"
                          min="10"
                          pattern=".{10}"
                          @keypress="validateNumber($event, objeto.celular, 10)"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- ----- INFORMACION PROFESIONAL ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información profesional</h4>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Escolaridad</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          id="input-estadocivil"
                          v-model="objeto.escolaridad_terminada"
                          required
                          :options="[
                            { text: 'Ninguna', value: 'Ninguna' },
                            { text: 'Primaria', value: 'Primaria' },
                            { text: 'Secundaria', value: 'Secundaria' },
                            { text: 'Preparatoria', value: 'Preparatoria' },
                            { text: 'Técnico', value: 'Técnico' },
                            { text: 'Profesional', value: 'Profesional' },
                            { text: 'Maestría', value: 'Maestría' },
                            { text: 'Doctorado', value: 'Doctorado' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b><label class="form-check-label">Estado civil</label> </b>
                      <div class="mb-4">
                        <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          id="input-estadocivil"
                          v-model="objeto.estado_civil"
                          required
                          :options="[
                            { text: 'Soltera', value: 'Soltera' },
                            { text: 'Casada', value: 'Casada' },
                            { text: 'Unión libre', value: 'Unión libre' },
                            { text: 'Divorciada', value: 'Divorciada' },
                            { text: 'Viuda', value: 'Viuda' },
                          ]"
                        ></b-form-select>
                      </div>
                      </div>
                    </v-col>
                    <v-col md="4">
                      <b><label class="form-check-label">Ocupación</label> </b>
                      <div class="mb-4">
                        <Multiselect
                          multiple
                          v-model="objeto.ocupacion"
                          required
                          :options="[
                            'Empleada domestica',
                            'Empleada en Empresa Privada o A.C',
                            'Empresaria',
                            'Gobierno',
                            'Hogar',
                            'Maquiladora',
                            'Negocio propio',
                            'Otro',
                            'Pensionada'
                          ]"                          
                        ></Multiselect>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Ingresos mensuales</label> </b>
                      <div class="mb-4">
                        <b-form-select 
                          class="form-select"
                          v-model="objeto.ingreso_mensual"
                          required
                          :options="[
                            { text: 'Sin ingresos', value: 'Sin ingresos' },
                            { text: 'Entre $1 y $2,500', value: '1 - 2500' },
                            { text: 'Entre $2,500 y $4,000', value: '2500 - 4000' },
                            { text: 'Entre $4,000 y $6,000', value: '4000 - 6000' },
                            { text: 'Entre $6,000 y $8,000', value: '6000 - 8000' },
                            { text: '$8,000 o más', value: '+8000' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <b
                        ><label class="form-check-label">Tiene hijos</label>
                      </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="hijos"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="2" v-if="hijos == 'Si'">
                      <b><label class="form-check-label">Número de hijas/hijos</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.cantidad_hijos"
                          id="input-md"
                          type="number"
                          :required="hijos == 'Si'"
                          @keypress="validateNumber($event, objeto.cantidad_hijos, 2)"
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="hijos == 'Si'">
                      <b><label class="form-check-label">A qué edad se tuvo su primer hija/hijo</label> </b>
                      <div class="mb-4">
                        <b-form-select 
                          class="form-select"
                          v-model="objeto.edad_primer_hijo"
                          :required="hijos == 'Si'"
                          :options="[
                            { text: 'Entre 10 y 14 años', value: '10 - 14' },
                            { text: 'Entre 15 y 19 años', value: '15 - 19' },
                            { text: 'Entre 20 y 24 años', value: '20 - 24' },
                            { text: 'Entre 25 o más', value: '+25' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Número de dependientes económicos</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.cantidad_dependientes_economicos"
                          id="input-md"
                          required
                          @keypress="validateNumber($event, objeto.cantidad_dependientes_economicos, 2)"
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- ----- INFORMACION SOBRE VIOLENCIA ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información sobre caso de violencia</h4>
                    </v-col>
                    <v-col md="3">
                      <b><label class="form-check-label">Ha vivido un episodio de violencia</label> </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="objeto.episodio_violencia"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.episodio_violencia == 'Si'">
                      <b><label class="form-check-label">Cuál tipo de violencia</label> </b>
                      <div class="mb-4">
                        <Multiselect
                          multiple
                          v-model="objeto.tipo_violencia"
                          :required="objeto.episodio_violencia == 'Si'"
                          :options="[
                            'Física',
                            'Psicológica',
                            'Económica',
                            'Patrimonial',
                            'Obstétrica',
                            'Sexual'
                          ]"
                        ></Multiselect>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="objeto.episodio_violencia == 'Si'">
                      <b><label class="form-check-label">En qué lugar</label> </b>
                      <div class="mb-4">
                        <b-form-select 
                          class="form-select"
                          v-model="objeto.lugar_violencia"
                          :required="objeto.episodio_violencia == 'Si'"
                           :options="[
                            { text: 'Familia', value: 'Familia' },
                            { text: 'Trabajo', value: 'Trabajo' },
                            { text: 'Escuela', value: 'Escuela' },
                            { text: 'Transporte', value: 'Transporte' },
                            { text: 'En la calle', value: 'En la calle' },
                            { text: 'En hospital', value: 'En hospital' },
                          ]"
                        ></b-form-select>
                      </div>
                    </v-col>
                  </v-row>


                  <!-- ----- INFORMACION DE REDES SOCIALES ------ -->
                  <v-row>
                    <v-col md="12">
                      <h4 class="card-title">Información de redes sociales</h4>
                    </v-col>
                    <v-col md="3">
                      <b-form-group label="Cuenta con redes sociales:">
                        <b-form-checkbox-group
                          id="checkbox-group-2"
                          v-model="objeto.redes_sociales"
                          name="flavour-2"
                        >
                          <b-form-checkbox value="Facebook">Facebook</b-form-checkbox>
                          <b-form-checkbox value="Instagram">Instagram</b-form-checkbox>
                          <b-form-checkbox value="TikTok">TikTok</b-form-checkbox>
                          <b-form-checkbox value="Otra">Otra..</b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </v-col>
                     <v-col md="3">
                      <b>
                        <label class="form-check-label">Cuenta con WhatsApp</label>
                      </b>
                      <div class="mb-4">
                        <b-form-group>
                          <b-form-radio-group
                            v-model="whatsapp"
                            class="d-flex gap-2"
                          >
                            <b-form-radio value="Si">Si</b-form-radio>
                            <b-form-radio value="No">No</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </v-col>
                    <v-col md="3" v-if="whatsapp == 'Si'">
                      <b><label class="form-check-label">Número de WhatsApp</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.whatsapp"
                          placeholder="Celular de WhatsApp"
                          min="10"
                          pattern=".{10}"
                          @keypress="validateNumber($event, objeto.whatsapp, 10)"
                          required
                        ></b-form-input>
                      </div>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col md="12"> 
                      <h4 class="card-title" > Información de control</h4>
                    </v-col>
                    <v-col md="4"> 
                      <b><label class="form-check-label " > Estado</label> </b>
                      <div class="mb-4">
                        <b-form-select
                          class="form-select"
                          v-model="objeto.estatus"
                          size="lg"
                          :options="estatus"
                        ></b-form-select>
                      </div>
                    </v-col> 
                    <v-col md="4"> 
                      <b> <label class="form-check-label " > Fecha de creación</label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_creacion"
                          id="fecha_creacion"
                          placeholder="Fecha de creación"
                          type="date"
                          disabled
                        ></b-form-input>
                      </div>
                    </v-col>
                    <v-col md="4"> 
                      <b><label class="form-check-label " > Última actualización </label> </b>
                      <div class="mb-4">
                        <b-form-input
                          v-model="objeto.fecha_modificacion"
                          id="fecha_modificacion"
                          placeholder="Última actualización"
                          type="date"
                          disabled
                        ></b-form-input>
                      </div>
                    </v-col>  
                  </v-row>
                </v-row> 
                 <v-row>
                  <v-col md="12">
                    <!-- <input class="btn btn-primary boton-submit" type="submit" value="Guardar"> -->
                    <v-btn
                      color="primary"
                      type="button"
                      @click="checkForm($event)"
                    >
                      Guardar
                    </v-btn> 
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <router-link to="/Mujeres">
                      <v-btn
                        color="error"
                        type="button"
                      >
                        Cancelar
                      </v-btn>
                    </router-link>
                  </v-col>
                </v-row>
                </v-col>
              </div>
            </b-form>
          </v-card>
        </v-col>
      </v-row>
</Layout>
</template>
